import React from 'react';
import { useTranslation } from 'react-i18next';

const WEEK_DAYS = [
  ['mon', 'Monday'], ['tue', 'Tuesday'], ['wed', 'Wednesday'], ['thu', 'Thursday'],
  ['fri', 'Friday'], ['sat', 'Saturday'], ['sun', 'Sunday'],
];

// Shared structured weekly opening-hours editor used by both the business owner
// dashboard and the admin business-edit modal so they stay in lock-step.
const WeeklyHoursEditor = ({ hours = {}, onChange, testIdPrefix = 'hours' }) => {
  const { t } = useTranslation();
  const setDay = (key, patch) =>
    onChange({ ...(hours || {}), [key]: { ...((hours || {})[key] || {}), ...patch } });

  return (
    <div className="space-y-1.5" data-testid="opening-hours-editor">
      {WEEK_DAYS.map(([key, label]) => {
        const d = (hours || {})[key] || {};
        return (
          <div key={key} className="flex items-center gap-2 text-sm">
            <span className="w-20 text-gray-600">{label}</span>
            <label className="flex items-center gap-1 text-xs text-gray-500">
              <input type="checkbox" checked={!!d.closed} onChange={(e) => setDay(key, { closed: e.target.checked })} data-testid={`${testIdPrefix}-closed-${key}`} />
              {t('closed', 'Closed')}
            </label>
            {!d.closed && (
              <>
                <input type="time" value={d.open || ''} onChange={(e) => setDay(key, { open: e.target.value })}
                  className="px-2 py-1 border border-gray-300 rounded text-xs" data-testid={`${testIdPrefix}-open-${key}`} />
                <span className="text-gray-400">–</span>
                <input type="time" value={d.close || ''} onChange={(e) => setDay(key, { close: e.target.value })}
                  className="px-2 py-1 border border-gray-300 rounded text-xs" data-testid={`${testIdPrefix}-close-${key}`} />
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WeeklyHoursEditor;
